import { type FormEvent, useState } from 'react';
import { ApiError } from '../api/client';
import { getDeviceName, useAuth } from './AuthProvider';

export function LoginScreen() {
  const { bootstrapped, signIn, bootstrap } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [deviceName, setDeviceName] = useState(getDeviceName());
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const creating = !bootstrapped;

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    setBusy(true);
    try {
      if (creating) await bootstrap(email, password, deviceName);
      else await signIn(email, password, deviceName);
    } catch (cause) {
      setError(
        cause instanceof ApiError ? cause.message : 'Connexion impossible. Réessayez.',
      );
      setBusy(false);
    }
  }

  return (
    <main className="safe-top safe-bottom mx-auto flex min-h-dvh max-w-md flex-col px-6 py-10">
      <header>
        <h1 className="text-3xl font-semibold tracking-tight">Budget</h1>
        <p className="mt-2 text-ink-secondary">
          {creating
            ? 'Merci de créer votre compte utilisateur pour cette instance.'
            : 'Combien reste-t-il à vivre ce mois-ci ?'}
        </p>
      </header>

      <form onSubmit={submit} className="mt-[50px] flex flex-col gap-4">
        <label className="flex flex-col gap-1.5">
          <span className="text-sm text-ink-secondary">Adresse électronique</span>
          <input
            type="email"
            required
            autoComplete="username"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            className="rounded-xl border border-line bg-surface px-4 py-3 text-base outline-none focus:border-series"
          />
        </label>

        <label className="flex flex-col gap-1.5">
          <span className="text-sm text-ink-secondary">Mot de passe</span>
          <input
            type="password"
            required
            minLength={10}
            autoComplete={creating ? 'new-password' : 'current-password'}
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            className="rounded-xl border border-line bg-surface px-4 py-3 text-base outline-none focus:border-series"
          />
        </label>

        <label className="flex flex-col gap-1.5">
          <span className="text-sm text-ink-secondary">Nom de cet appareil</span>
          <input
            type="text"
            required
            maxLength={60}
            value={deviceName}
            onChange={(event) => setDeviceName(event.target.value)}
            className="rounded-xl border border-line bg-surface px-4 py-3 text-base outline-none focus:border-series"
          />
          <span className="text-xs text-ink-muted">
            Sert à savoir qui a saisi quoi. Modifiable ensuite.
          </span>
        </label>

        {error !== null && (
          <p role="alert" className="text-sm text-critical">
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={busy}
          className="mt-2 rounded-xl bg-series px-4 py-4 text-base font-medium text-white disabled:opacity-60"
        >
          {busy ? 'Un instant…' : creating ? 'Créer le compte' : 'Se connecter'}
        </button>
      </form>
    </main>
  );
}
